import { Divider, ListItemButton, ListItemText } from '@mui/material';
import React from 'react';
import { Link, useMatch } from 'react-router-dom';

const NavbarItem: React.FC<{ item: { label: string; path: string; bottomDivider?: boolean }; toggle: () => void }> = ({ item, toggle }) => {
  const isActive = useMatch(item.path);

  return (
    <>
      <ListItemButton
        sx={{
          backgroundColor: isActive ? '#c8e4f1' : 'inherit',
          '&:hover': { backgroundColor: '#c8e4f154' },
          cursor: 'pointer',
        }}
        key={item.path}
        component={Link}
        to={item.path}
        onClick={toggle}
      >
        <ListItemText primary={item.label} />
      </ListItemButton>

      {item.bottomDivider ? <Divider sx={{ my: 1 }} /> : null}
    </>
  );
};

export default NavbarItem;
